import React from "react";
import { Images } from "../Common/Images.jsx";
import { useTranslation } from "react-i18next";
import WarningIcon from "../../assets/images/icons/Warningicon.svg";
import WarningcloseIcon from "../../assets/images/icons/close.svg";

const NoVehiclePopUp = ({ onClose, onConfirm, variant = "green", message = "" }) => {
  const { t } = useTranslation("common");

  if (variant === "orange") {
    return (
      <div
        className="modal"
        style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
        id="dateModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="dateModalLabel"
        aria-hidden="true"
      >
        <div className="modal fade show alertpopup d-block">
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="popup-title">{t("warning")}</h5>
                  <div className="close-modal">
                    <a onClick={onClose}>
                      <img src={WarningcloseIcon} aria-label="Close" />
                    </a>
                  </div>
                </div>
                <div className="modal-des mt-35">
                  <p>{message || t("no_vehicle_alert")}</p>
                  <div className="modal-img text-center">
                    <img className="warning-icon" src={WarningIcon} alt="Warning Icon" />
                  </div>

                  <div className="d-flex justify-content-end gap-3 mt-4">
                    <button
                      type="button"
                      className="main-btn outline-alert-btn w-full"
                      onClick={onConfirm}
                    >
                      {t("confirm")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="modal"
      style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
      id="dateModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="dateModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-custom-width">
        <div className="modal-content modal-radius">
          <div className="modal-body">
            <div className="close-modal">
              <a className="close-modal" onClick={onClose}>
                <img src={Images.Close} alt="Close" />
              </a>
            </div>
            <div className="pt-2">
              <h5 className="popup-title">{t("warning")}</h5>
            </div>
            <div className="form-row mb-3">
              <label>{t("first_login_settings_msg")}</label>
            </div>

            <div className="tags-btn mt-4">
              <button
                className="w-100 min-height-56 selected"
                onClick={onConfirm}
                type="button"
              >
                {t("confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoVehiclePopUp;
